import { render, staticRenderFns } from "./UpdateEhsExpiration.vue?vue&type=template&id=79d8adda&scoped=true"
import script from "./UpdateEhsExpiration.vue?vue&type=script&lang=js"
export * from "./UpdateEhsExpiration.vue?vue&type=script&lang=js"
import style0 from "./UpdateEhsExpiration.vue?vue&type=style&index=0&id=79d8adda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d8adda",
  null
  
)

export default component.exports